import { render, staticRenderFns } from "./AddEmails.vue?vue&type=template&id=2e4dc8c8&scoped=true&"
import script from "./AddEmails.vue?vue&type=script&lang=js&"
export * from "./AddEmails.vue?vue&type=script&lang=js&"
import style0 from "./AddEmails.vue?vue&type=style&index=0&id=2e4dc8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4dc8c8",
  null
  
)

export default component.exports